<script lang="ts">
  export let colour = "var(--surface)";
  $: style = `background: ${colour}`;
</script>

<style lang="scss">
  .dot {
    float: left;
    width: 4px;
    height: 4px;
    margin: 0 4px;
    border-radius: 50%;
    opacity: 0;
    animation: loadingFade 800ms infinite;
  }

  .dot:nth-child(1) {
    animation-delay: 0s;
  }

  .dot:nth-child(2) {
    animation-delay: 0.2s;
  }

  .dot:nth-child(3) {
    animation-delay: 0.4s;
  }

  @keyframes loadingFade {
    0% {
      opacity: 0;
    }
    50% {
      opacity: 0.8;
    }
    100% {
      opacity: 0;
    }
  }
</style>

<div class="dot" {style} />
<div class="dot" {style} />
<div class="dot" {style} />
